import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from '../utils';
import history from 'src/utils/history';

export const deleteRecord = (entityId, recordId, permanently) => {
  const sessionId = getSessionId();
  let params = {
    entityId
  };
  if (permanently) {
    params['remove'] = true;
  }

  return dispatch => {
    axios({
      method: 'DELETE',
      url: '/openempi-ws-rest/1.0/records/' + recordId,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: params
    })
      .then(res => {
        dispatch(deleteRecordSuccess(res.data));
      })
      .catch(err => {
        dispatch(deleteRecordFailure(err));
      });
  };
};

export const updateRecord = (recordId, record, path) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/records/' + recordId,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: record
    })
      .then(res => {
        dispatch(updateRecordSuccess(res.data));
        history.push(path);
      })
      .catch(err => {
        dispatch(updateRecordFailure(err));
      });
  };
};

export const generateAllRecordLinks = entityId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/records/record-links',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityId
      }
    })
      .then(res => {
        dispatch(generateAllRecordLinksSuccess(res.data));
      })
      .catch(err => {
        dispatch(generateAllRecordLinksFailure(err));
      });
  };
};

export const findByAttributes = (entityVersionId, searchValues) => {
  const sessionId = getSessionId();

  const queryAttribs = new URLSearchParams();
  Object.keys(searchValues).forEach(key => {
    if (searchValues[key] !== null && searchValues[key] !== '') {
      queryAttribs.append('keyVal', key + ',' + searchValues[key]);
    }
  });
  queryAttribs.append('entityId', entityVersionId);
  queryAttribs.append('firstResult', 0);
  queryAttribs.append('maxResults', 500);

  return dispatch => {
    dispatch(findByAttributesRequest(searchValues));
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/records/findByAttributes',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: queryAttribs
    })
      .then(res => {
        dispatch(findByAttributesSuccess(res.data));
      })
      .catch(err => {
        dispatch(findByAttributesFailure(err));
      });
  };
};

export const findByRecordIds = (entityVersionId, searchValues) => {
  const sessionId = getSessionId();

  const ids = searchValues.split(',');

  const queryAttribs = new URLSearchParams();
  ids.forEach(id => {
    if (id !== null && id !== '') {
      queryAttribs.append('recordId', id.trim());
    }
  });
  queryAttribs.append('entityId', entityVersionId);
  queryAttribs.append('firstResult', 0);
  queryAttribs.append('maxResults', 500);

  return dispatch => {
    dispatch(findByRecordIdsRequest(searchValues));
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/records',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: queryAttribs
    })
      .then(res => {
        dispatch(findByRecordIdsSuccess(res.data));
      })
      .catch(err => {
        dispatch(findByRecordIdsFailure(err));
      });
  };
};

export const findByIdentifier = (entityVersionId, queryAttribs) => {
  const sessionId = getSessionId();
  const { identifier, identifierDomainId } = queryAttribs;

  const params = {
    entityId: entityVersionId,
    firstResult: 0,
    maxResults: 500,
    identifier: identifier
  };
  if (identifierDomainId !== -1) {
    params['identifierDomainId'] = identifierDomainId;
  }

  return dispatch => {
    dispatch(findByIdentifierRequest(queryAttribs));
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/records/findByIdentifier',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: params
    })
      .then(res => {
        dispatch(findByIdentifierSuccess(res.data));
      })
      .catch(err => {
        dispatch(findByIdentifierFailure(err));
      });
  };
};

export const loadRecordByIdSearch = (entityId, recordId) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/records/' + recordId,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId,
        includeCustom: true
      }
    })
      .then(res => {
        dispatch(loadRecordByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(loadRecordByIdFailure(err));
      });
  };
};

export const loadRecordHistoryById = (entityId, recordId) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/records/' + recordId + '/history',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(loadRecordHistoryByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(loadRecordHistoryByIdFailure(err));
      });
  };
};

export const findRecordLinks = (entityVersionId, recordId) => {
  const sessionId = getSessionId();

  const params = {
    entityId: entityVersionId,
    state: 'A',
    direct: 'Y'
  };

  return dispatch => {
    dispatch(findRecordLinksRequest());
    axios({
      method: 'get',
      url: `/openempi-ws-rest/1.0/record-links/record/${recordId}`,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params
    })
      .then(res => {
        dispatch(findRecordLinksSuccess(res.data));
      })
      .catch(err => {
        dispatch(findRecordLinksFailure(err));
      });
  };
};

export const clearRecordError = () => {
  return {
    type: Constants.RECORD_CLEAR_ERROR
  };
};

export const clearSearchAttributes = () => {
  return {
    type: Constants.FIND_CLEAR_ATTRIBUTES
  };
};

const findByAttributesRequest = searchValues => {
  return {
    type: Constants.FINDBYATTRIBUTES_REQUEST,
    payload: searchValues
  };
};

const findByAttributesSuccess = data => {
  return {
    type: Constants.FINDBYATTRIBUTES_SUCCESS,
    payload: data
  };
};

const findByAttributesFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.FINDBYATTRIBUTES_FAILURE,
    payload
  };
};

const findByRecordIdsRequest = searchValues => {
  return {
    type: Constants.FINDBYRECORDIDS_REQUEST,
    payload: searchValues
  };
};

const findByRecordIdsSuccess = data => {
  return {
    type: Constants.FINDBYRECORDIDS_SUCCESS,
    payload: data
  };
};

const findByRecordIdsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.FINDBYRECORDIDS_FAILURE,
    payload
  };
};

const findByIdentifierRequest = searchValues => {
  return {
    type: Constants.FINDBYIDENTIFIER_REQUEST,
    payload: searchValues
  };
};

const findByIdentifierSuccess = data => {
  return {
    type: Constants.FINDBYIDENTIFIER_SUCCESS,
    payload: data
  };
};

const findByIdentifierFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.FINDBYIDENTIFIER_FAILURE,
    payload
  };
};

const updateRecordSuccess = data => {
  return {
    type: Constants.RECORD_UPDATE_SUCCESS,
    payload: data
  };
};

const updateRecordFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.RECORD_UPDATE_FAILURE,
    payload
  };
};

const generateAllRecordLinksSuccess = data => {
  return {
    type: Constants.RECORD_GENLINKS_SUCCESS,
    payload: data
  };
};

const generateAllRecordLinksFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.RECORD_GENLINKS_FAILURE,
    payload
  };
};

const deleteRecordSuccess = data => {
  return {
    type: Constants.RECORD_DELETE_SUCCESS,
    payload: data
  };
};

const deleteRecordFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.RECORD_DELETE_FAILURE,
    payload
  };
};

const findRecordLinksRequest = () => {
  return {
    type: Constants.FIND_RECORDLINKS_REQUEST
  };
};

const findRecordLinksSuccess = data => {
  return {
    type: Constants.FIND_RECORDLINKS_SUCCESS,
    payload: data
  };
};

const findRecordLinksFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.FIND_RECORDLINKS_FAILURE,
    payload
  };
};

const loadRecordByIdSuccess = data => {
  return {
    type: Constants.FIND_RECORDBYID_SUCCESS,
    payload: data
  };
};

const loadRecordByIdFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.FIND_RECORDBYID_FAILURE,
    payload
  };
};

const loadRecordHistoryByIdSuccess = data => {
  return {
    type: Constants.LOAD_RECORDHISTORYBYID_SUCCESS,
    payload: data
  };
};

const loadRecordHistoryByIdFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.LOAD_RECORDHISTORYBYID_FAILURE,
    payload
  };
};
